import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { LandingComponent } from './features/landing/landing.component';
import { AdminCenterComponent } from './features/admin-center/admin-center.component';
import { CalculatorResultsComponent } from './features/calculator-results/calculator-results.component';
import { AuthGuardService } from './service/auth-guard.service';
import { InvalidPermissionsComponent } from './features/invalid-permissions/invalid-permissions.component';
import { UnderMaintenanceComponent } from './features/under-maintenance/under-maintenance.component';
import { MaintenanceGuardService } from './service/maintenance-guard.service';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent, 
    canActivate: [MsalGuard, MaintenanceGuardService]
  },
  {
    path: 'calculator',
    component: CalculatorResultsComponent,
    canActivate: [MsalGuard, MaintenanceGuardService]
  },
  {
    path: 'admin',
    component: AdminCenterComponent,
    canActivate: [MsalGuard, AuthGuardService, MaintenanceGuardService]
  },
  {
    path: 'invalid',
    component: InvalidPermissionsComponent,
    canActivate: [MsalGuard, MaintenanceGuardService]
  },
  {
    path: 'under-maintenance',
    component: UnderMaintenanceComponent
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
